// extracted by mini-css-extract-plugin
module.exports = {"container":"ProfileSocialMedialLinks_container__7YDyE","sending":"ProfileSocialMedialLinks_sending__1eRxU"};